import { IAnyObject } from '../../interfaces'
import * as API from '../Api'
import { connect, disconnect, subscribe as subscribeOnTopic } from './MQTTActions'

export type TServiceMQTTMessage = {
    action: 'force_update_pallets'
    consumer: 'widget'
    epoch: number
    data: IAnyObject
}

export const subscribe = (listener: (message: TServiceMQTTMessage) => void): void => {
    API.WidgetsApi.getAccount()
        .then(account => {
            if (!account.AccountId) {
                return
            }
            subscribeOnTopic([`company/${account.AccountId}`])

            connect((message: string, topic: string): void => {
                const msg = JSON.parse(message) as IAnyObject

                if (msg.consumer === 'widget') {
                    listener(msg as TServiceMQTTMessage)
                }
            })
        })
        .catch(console.error)
}

export const unsubscribe = (): void => {
    disconnect()
}
